import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import BodyConsejero from "../../../components/Consejero/BodyConsejero/BodyConsejero";
import MainSelect from "../../../components/General/MainSelect";
import GeneralService from "../../../../services/general";
import ConfiguracionService from "../../../../services/configuracion";
import { CODES } from "../../../../utils/responseCodes";
import { simpleAlerts } from "../../../../utils/alerts";
import SpinnerLoader from "../../../components/SpinnerLoad/SpinnerLoader";

const Consejero = () => {
  const [titleSpinner, setTitleSpinner] = useState(null);
  const [openModalLoader, setOpenModalLoader] = useState(true);

  const [clients, setClients] = useState([]);
  const [infoClient, setInfoClient] = useState(null);

  const [cecos, setCecos] = useState([]);

  // Catálogos
  const [tiposSeguro, setTiposSeguro] = useState([]);
  const [modalidades, setModalidades] = useState([]);

  const [configuraciones, setConfiguraciones] = useState([]);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (infoClient) {
      getCecosByCliente();
    } else {
      setCecos([]);
    }
  }, [infoClient]);

  const init = async () => {
    setOpenModalLoader(true);

    try {
      await Promise.all([
        getClientesSghh(),
        getConfiguracionCeco(),
        getConfiguracionesCeco(),
      ]);
    } finally {
      setOpenModalLoader(false);
    }
  };

  const getClientesSghh = async () => {
    await GeneralService.getClientesSghh()
      .then((result) => {
        if (result.status === CODES.SUCCESS_200) {
          const data = result.data.map((item) => ({
            ...item,
            id: item.idcliente,
            value: item.idcliente,
            label: item.cliente,
          }));

          setClients(data);
        } else {
          simpleAlerts("Hubo un error en Clientes", "error");
        }
      })
      .catch((err) => {
        console.log("getClientesSghh", err);
        simpleAlerts("Hubo un error al obtener los clientes", "error");
      });
  };

  const getConfiguracionCeco = async () => {
    await ConfiguracionService.getConfiguracionCeco()
      .then((result) => {
        if (result.status === CODES.SUCCESS_200) {
          setTiposSeguro(result.data?.tiposSeguro || []);
          setModalidades(result.data?.modalidades || []);
        } else {
          simpleAlerts(
            "Hubo un error al obtener las configuraciones de CECO",
            "error"
          );
        }
      })
      .catch((err) => {
        console.log("getConfiguracionCeco", err);

        simpleAlerts(
          "Hubo un error al obtener las configuraciones de CECO",
          "error"
        );
      });
  };

  const getConfiguracionesCeco = async () => {

    await ConfiguracionService.getConfiguracionesCeco()
        .then((result) => {

            if (result.status === CODES.SUCCESS_200) {

                setConfiguraciones(
                    result.data?.data || []
                );

            } else {

                simpleAlerts(
                    "Hubo un error al obtener las configuraciones.",
                    "error"
                );
            }

        })
        .catch((err) => {
            console.log(
                "getConfiguracionesCeco",
                err
            );
        });
  };

  const getCecosByCliente = () => {
    setOpenModalLoader(true);

    GeneralService.getClientesCecoByEmpresa(infoClient)
      .then((result) => {
        if (result.status === CODES.SUCCESS_200) {
          const data = result.data
            .filter((x) => x.idcliente === infoClient)
            .map((x) => {
              const idceco = x.idagrupamientocompañia.trim();

              const configuracion = configuraciones.find(
                (config) => config.idceco?.trim() === idceco,
              );

              return {
                id: idceco,
                ceco: x.agrupamientocompañia,
                tipo: configuracion?.idtipoSeguro ?? "",
                modalidad: configuracion?.idmodalidad ?? "",
                dia_envio: configuracion?.dia_envio ?? "",
                estado: configuracion ? "GUARDADO" : "SIN_CONFIGURAR",
              };
            });

          setCecos(data);
        } else {
          simpleAlerts(
            "Hubo un error al obtener los CECO",
            "error"
          );
        }
      })
      .catch((err) => {
        console.log("getCecosByCliente", err);

        simpleAlerts(
          "Hubo un error al obtener los CECO",
          "error"
        );
      })
      .finally(() => setOpenModalLoader(false));
  };

  return (
    <Box sx={{ flexGrow: 1 }}>

      <Grid
        container
        justifyContent="center"
        mb={2}
      >
        <Grid item xs={10} md={5}>
          <MainSelect
            title="Cliente"
            options={clients}
            value={infoClient}
            onChange={(value) => setInfoClient(value)}
          />
        </Grid>
      </Grid>

      <Grid container justifyContent="center">
        <Grid item xs={12} md={10}>

          <BodyConsejero
            cecos={cecos}
            setCecos={setCecos}
            tiposSeguro={tiposSeguro}
            modalidades={modalidades}
            setOpenModalLoader = {setOpenModalLoader}
          />

        </Grid>
      </Grid>

      <SpinnerLoader
        open={openModalLoader}
        title={titleSpinner}
      />

    </Box>
  );
};

export default Consejero;